import { Box, IconButton, styled } from '@mui/material';
import pallet from '../../../layouts/pallet';

export const DropzoneWrapper = styled(Box)(({ theme }) => ({
  border: `2px dashed ${pallet.primary}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: pallet.lightGrey,
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: pallet.secondaryHover
  }
}));

export const BrowseText = styled('span')({
  color: pallet.primary,
  fontWeight: 'bold'
});

export const PreviewContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  border: `1px solid ${pallet.divider}`,
  borderRadius: theme.shape.borderRadius,
  display: 'inline-block',
  position: 'relative'
}));

// NEW: Styled component for the delete button to match the design
export const DeleteButtonStyled = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  backgroundColor: pallet.lightGrey,
  padding: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: pallet.selectedBackground
  }
}));
